import style from './PaymentMethod.module.css'

import classNames from 'classnames/bind'
import useTranslation from 'next-translate/useTranslation'

export default function PaymentMethod ({ id, type, name, percentFee, balance, currency, locale, selected, onClick, onSelect }) {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)

  let title
  switch (type) {
    case 'visa':
      title = t('paymentmethod-type-visa')
      break
    case 'mastercard':
      title = t('transactions-type-mastercard')
      break
    case 'amex':
      title = t('transactions-type-amex')
      break
    case 'paypal':
      title = t('transactions-type-paypal')
      break
    case 'paynow':
      title = ''
      break
    case 'bank':
      title = t('transactions-type-bank')
      break
    case 'creditcard':
      title = ''
      break
    case 'crypto':
      title = t('paymentmethod-type-crypto')
      break
  }

  const handleClick = e => {
    if (e.target.tagName !== 'INPUT') {
      e.preventDefault()
      onSelect && document.getElementById('pm_' + id).click()
      onClick && onClick(e)
    } else {
      e.stopPropagation()
      onSelect && onSelect(e)
    }
  }

  return (
    <a href='#' onClick={handleClick} className={c('paymentmethod')} title={title + ' ' + name}>
      {onSelect && <div className={c('select')}><input name='paymentmethod' required type='radio' id={'pm_' + id} value={id} key={new Date().toISOString()} defaultChecked={selected} /></div>}
      <div className={c('type', type)} />
      <label htmlFor={onSelect ? 'pm_' + id : undefined}>
        <h4>{name}</h4>
        {currency && (balance
          ? <span className={c('balance')}>{(balance || 0).toLocaleString(locale, { style: 'currency', currency: currency, currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          : <span className={c('currency')}>{currency}</span>)}
        {currency && percentFee(currency) > 0 && <span className={c('fee')}>({t('paymentmethod-fee-percent', { percent: percentFee(currency).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }) })})</span>}
      </label>
    </a>
  )
}
